const production = process.env.NODE_ENV === "production";
export const cc = {
    production: production,
    name: "Book N Order",
    color: "#ef7a17",
    timezone: "Pacific/Auckland",
    currency: {
        symbol: "$",
        code: "NZD",
        precision: 2,
        step: "0.01",
    },
    hosts: {
        stores: "booknorder.co.nz",
        admin: "admin.booknorder.co.nz",
        all: ["booknorder.co.nz", "booknorder-test.com"],
    },
    s3: {
        restaurantImages: "https://bno-restaurant-images.s3-ap-southeast-2.amazonaws.com",
    },
    emails: {
        support: "support@booknorder.co.nz",
    },
    api: {
        url: production ? "https://api.booknorder.co.nz" : "https://api.booknorder-local.co.nz:3444",
        publicKey: "c2285f76-cc39-4ade-9269-023192e1798b",
    },
    aws: {
        s3: "https://s3.amazonaws.com/ordering-platform",
        cloudfront: "https://dol98aud6tbh0.cloudfront.net",
    },
    mapbox: {
        apiKey: "pk.eyJ1IjoiYm9va25vcmRlciIsImEiOiJjazJmcTlqdzYwYTM4M2lsaHRnbXhmMHRhIn0.O4Fx7YnYjERhkFkH0MMILg",
    },
    google: {
        apiKey: "AIzaSyDwyh2YidQHMgVLCiJAbUtMb87LyAwZX-4",
    },
    support: {
        phone: "07 808 2686",
    },
};
//# sourceMappingURL=config.js.map